import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import "aos/dist/aos.css";


function IoTDevelopment() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true })
  }, [])
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">IoT Development</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section iot-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Harness the Power of Connected Devices</h2>
              <p className="intro-text">
                At Codenix Infotech, we deliver end-to-end IoT services designed to help businesses unlock the full potential of connected devices. From strategic planning and device development to deployment, security, and analytics, our solutions are tailored to your unique business needs.
              </p>
            </div>

          </div>
          <div className="intro-image iot-graphic">

          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section iot-services">
        <div className="container">
          <div className="section-header">
            <h2 data-aos="fade-up">Our IoT Services</h2>
            <p className="section-description">
              Comprehensive IoT solutions to transform your business operations across various industries
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="100">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-heartbeat"></i>
              </div>
              <h3>IoT in Healthcare</h3>
              <p>Develop wearable devices and smart IoT systems to track real-time health data, enhance patient care, and reduce costs.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-industry"></i>
              </div>
              <h3>IoT in Manufacturing</h3>
              <p>Monitor equipment performance, predict maintenance needs, and minimize downtime to optimize productivity</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <h3>IoT in Agriculture</h3>
              <p>Use IoT-driven insights to improve crop yields, optimize irrigation, and ensure sustainable resource management.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-home"></i>
              </div>
              <h3>IoT in Smart Homes</h3>
              <p>Enable intelligent automation, remote control, and enhanced home security with connected IoT devices.
                .</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-city"></i>
              </div>
              <h3>Smart City Solutions</h3>
              <p>Build IoT infrastructure to optimize energy use, traffic flow, and urban services for a smarter, more sustainable future.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-truck"></i>
              </div>
              <h3>Supply Chain IoT</h3>
              <p>Implement IoT-enabled tracking systems for enhanced supply chain visibility, efficiency, and cost reduction.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Development Process Section */}
      <section className="design-process-section iot-process">
        <div className="container">
          <div className="section-header">
            <h2>Our IoT Development Process</h2>
            <p className="section-description">
              A strategic approach to delivering connected and intelligent IoT solutions for your business
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "IoT Strategy & Consulting",
                text: "We analyze business goals and industry needs to craft a tailored IoT adoption strategy                "
              },
              {
                num: 2,
                title: "IoT Architecture Design",
                text: "We design scalable, robust architectures to support device connectivity and large-scale data flow."
              },
              {
                num: 3,
                title: "Device Development",
                text: "We design, develop, and customize IoT sensors and devices for your unique use cases.                "
              },
              {
                num: 4,
                title: "Platform Deployment",
                text: "We deploy secure, reliable IoT platforms for seamless integration and data management.                "
              },
              {
                num: 5,
                title: "Security Implementation",
                text: "We integrate enterprise-grade security to safeguard IoT devices and networks from cyber threats.                "
              },
              {
                num: 6,
                title: "Data Analysis & Support",
                text: "We provide real-time analytics and ongoing support to optimize your IoT infrastructure.                "
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section iot-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our IoT Solutions</h2>
            <p className="section-description">
              What makes our IoT development services stand out from the rest
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            {[
              {
                icon: "fas fa-expand-arrows-alt",
                title: "Scalable Architecture",
                text: "Designed to grow with your business and handle high data volumes."
              },
              {
                icon: "fas fa-bolt",
                title: "Real-Time Insights",
                text: "Advanced encryption and security measures to protect your IoT ecosystem."
              },
              {
                icon: "fas fa-shield-alt",
                title: "Robust Security",
                text: "Advanced encryption and security measures to protect your IoT ecosystem. "
              },
              {
                icon: "fas fa-puzzle-piece",
                title: "Customized Solutions",
                text: "Built to match your business model and industry requirements."
              },
              {
                icon: "fas fa-plug",
                title: "Seamless Integration",
                text: "Easily integrates with your existing IT systems and workflows."
              },
              {
                icon: "fas fa-hands-helping",
                title: "Ongoing Support",
                text: "Continuous updates, optimization, and expert assistance. "
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section mt-5 iot-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Connect Your Business to the IoT Ecosystem?</h2>
            <p>Let's create innovative IoT solutions that drive efficiency, insights, and growth for your organization.</p>
            <a href="/contact" className="cta-button">Get a Free IoT Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default IoTDevelopment;
